module.exports = __webpack_public_path__ + "static/dresswing-logo-261eb0c4953e64f9929e148318f9cce0.png";